import { ref, onMounted, onUnmounted } from 'vue';
import type { QualityPreset } from '../types';
import { isDiscordHost } from '../net';

export interface DesktopSource {
  id: string;
  name: string;
  thumbnail: string;
  appIcon: string | null;
  isDiscord: boolean;
}

export function useDesktopCompanion() {
  const isCompanionOnline = ref(false);
  const isCompanionStreaming = ref(false);
  const isFetchingSources = ref(false);
  const sources = ref<DesktopSource[]>([]);
  const lastError = ref<string | null>(null);

  let pollInterval: number | undefined;

  async function checkCompanion() {
    try {
      const res = await fetch('http://127.0.0.1:48123/status', {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        signal: AbortSignal.timeout ? AbortSignal.timeout(2000) : undefined,
      });
      if (res.ok) {
        const data = await res.json();
        isCompanionOnline.value = true;
        isCompanionStreaming.value = !!data.isStreaming;
      } else {
        isCompanionOnline.value = false;
        isCompanionStreaming.value = false;
      }
    } catch (e) {
      isCompanionOnline.value = false;
      isCompanionStreaming.value = false;
    }
  }

  async function fetchSources(): Promise<DesktopSource[]> {
    if (!isCompanionOnline.value) return [];
    isFetchingSources.value = true;
    try {
      const res = await fetch('http://127.0.0.1:48123/sources', {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
      });
      if (res.ok) {
        const list: DesktopSource[] = await res.json();
        sources.value = list;
        return list;
      }
    } catch (err: any) {
      console.warn('[Companion] Falha ao buscar janelas:', err);
    } finally {
      isFetchingSources.value = false;
    }
    return [];
  }

  async function startDesktopStream(params: {
    sourceId: string;
    sourceName?: string;
    roomId: string;
    streamerName: string;
    quality: QualityPreset;
  }): Promise<boolean> {
    try {
      const res = await fetch('http://127.0.0.1:48123/start', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
      });
      if (res.ok) {
        isCompanionStreaming.value = true;
        return true;
      }
    } catch (e: any) {
      lastError.value = 'Falha ao iniciar transmissão no companion: ' + e.message;
    }
    return false;
  }

  async function stopDesktopStream(): Promise<boolean> {
    try {
      const res = await fetch('http://127.0.0.1:48123/stop', {
        method: 'POST',
      });
      if (res.ok) {
        isCompanionStreaming.value = false;
        return true;
      }
    } catch (e) {}
    return false;
  }

  onMounted(() => {
    checkCompanion();
    pollInterval = window.setInterval(checkCompanion, 2500);
  });

  onUnmounted(() => {
    if (pollInterval) clearInterval(pollInterval);
  });

  return {
    isCompanionOnline,
    isCompanionStreaming,
    isFetchingSources,
    sources,
    lastError,
    checkCompanion,
    fetchSources,
    startDesktopStream,
    stopDesktopStream,
  };
}
